// extracted by mini-css-extract-plugin
module.exports = {"cookieCheckbox":"privacy-legal-module--cookieCheckbox--2t4Uu","cookieDescription":"privacy-legal-module--cookieDescription--2HVh3"};